import { createFileRoute } from '@tanstack/react-router'
import { studentSearchSchema } from '@/features/filter-students/model/studentSearch'
import { StudentsPage } from '@/pages/students/ui/StudentsPage'

export const Route = createFileRoute('/students')({
  validateSearch: studentSearchSchema,
  component: StudentsPage,
})
